import Util from "./Util";
import ResourceModel from "sap/ui/model/resource/ResourceModel";
import ResourceBundle from "sap/base/i18n/ResourceBundle";

export default class TranslationUtil {
  public static getText(sKey: string, aArgs?: any[]) {
    const component = Util.getComponent();
    if(!component) {
      return sKey;
    }

    const resourceModel: ResourceModel = component.getModel("i18n") as ResourceModel;
    const resourceBundle: ResourceBundle = resourceModel.getResourceBundle() as ResourceBundle;
    return resourceBundle.getText(sKey, aArgs);
  }

  public static getUpdateText(sType: string, arArguments?: any[]) {
    const sI118nText = sType ? "@ValueChangedSuccessfully" + sType : "@ValueHelpSuccessfullySaved";
    return this.getText(sI118nText, arArguments);
  }
}
